function parseObjectFromString(hashOrQueryString = '') {
  return hashOrQueryString
    .substring(1)
    .split('&')
    .reduce((params, pair) => {
      const [key, value] = pair.split('=');
      return value ? Object.assign({ [key]: value }, params) : params;
    }, {});
}

export function queryParser() {
  const brandParam = window.location.pathname.replace('/', '');
  const queryParams = parseObjectFromString(window.location.search);
  return {
    brandParam,
    queryParams
  };
}

export const redirectTo = (brochurewareUrl, brand, redirectionDelay) => {
  setTimeout(() => {
    window.location.href = brochurewareUrl[brand];
  }, redirectionDelay);
};
